import React from 'react'
import { SettingsFormValues } from 'src/Elements/SystemSettings/Battery/types'
import SettingsBox from 'src/Elements/Data/SettingsBox'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import useStyles from '../styles'
import { NumberField } from 'src/Libs/inputs/formik'
import { UnitTypes } from 'src/Libs/types'
import { Box } from '@mui/material'

interface Props {
  values: SettingsFormValues
}
const BatterySettingsList: React.VFC<Props> = ({ values }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  return (
    <Box px={4} py={2}>
      <SettingsBox
        title={t('systemSettings.battery.settings.voltage')}
        suffix={<NumberField name="voltage" value={Number(values.voltage)} disabled={true} className={classes.textField} suffix={UnitTypes.volt} />}
      />
    </Box>
  )
}

export default BatterySettingsList
